var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDonationId)?_c('span',[(_vm.donationType == 'amount')?[_vm._v(_vm._s(_vm.formattedAmount))]:_vm._e(),(_vm.donationType == 'date')?[_vm._v("("+_vm._s(_vm.formattedDate)+"-i adat)")]:_vm._e()],2):_c('LoadingDots')
}
var staticRenderFns = []

export { render, staticRenderFns }